export function parseChartPayload(raw, depth = 0) {
    if (depth > 4 || raw === null || raw === undefined)
        return null;
    if (typeof raw === "string") {
        // Strip markdown code fences (```json ... ``` or ``` ... ```)
        const stripped = raw
            .replace(/^```(?:json)?\s*/i, "")
            .replace(/\s*```$/, "")
            .trim();
        try {
            return parseChartPayload(JSON.parse(stripped), depth + 1);
        }
        catch {
            return null;
        }
    }
    if (typeof raw === "object") {
        const o = raw;
        if (o.plot_type === "pie") {
            // Case 1: flat labels/values arrays
            if (Array.isArray(o.labels) && Array.isArray(o.values)) {
                return o;
            }
            // Case 2: series[0].labels[] + series[0].values[] (flat arrays inside series)
            const pieSeries = o.series;
            if (Array.isArray(pieSeries) && pieSeries[0]) {
                const s0 = pieSeries[0];
                if (Array.isArray(s0.labels) && Array.isArray(s0.values)) {
                    return {
                        colors: o.colors,
                        labels: s0.labels.map(String),
                        plot_type: "pie",
                        title: String(o.title ?? ""),
                        values: s0.values.map(Number)
                    };
                }
                // Case 3: series[0].data[{label/name, value}]
                if (s0.data) {
                    const data = s0.data;
                    return {
                        colors: o.colors,
                        labels: data.map((d) => d.label ?? d.name ?? ""),
                        plot_type: "pie",
                        title: String(o.title ?? ""),
                        values: data.map((d) => d.value)
                    };
                }
            }
        }
        if (o.plot_type === "line" || o.plot_type === "bar") {
            const chartSeries = o.series;
            if (Array.isArray(chartSeries) && chartSeries.length > 0) {
                const series = chartSeries.map((s) => ({
                    name: String(s.name ?? ""),
                    x: Array.isArray(s.x) ? s.x.map(String) : [],
                    y: Array.isArray(s.y) ? s.y.map(Number) : []
                }));
                return {
                    plot_type: o.plot_type,
                    series,
                    title: String(o.title ?? ""),
                    x_label: o.x_label !== null && o.x_label !== undefined ? String(o.x_label) : undefined,
                    y_label: o.y_label !== null && o.y_label !== undefined ? String(o.y_label) : undefined
                };
            }
        }
        for (const val of Object.values(o)) {
            const found = parseChartPayload(val, depth + 1);
            if (found)
                return found;
        }
    }
    return null;
}
